module.exports = "/img/_/_/_/assets/images/creeper/battle/rare//15.jpg?816e6abfd0361cde192cd5ac7b37bdb4";